import { render, staticRenderFns } from "./SpeakerCarousel.vue?vue&type=template&id=2f7a980f&scoped=true&"
import script from "./SpeakerCarousel.vue?vue&type=script&lang=js&"
export * from "./SpeakerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerCarousel.vue?vue&type=style&index=0&id=2f7a980f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a980f",
  null
  
)

component.options.__file = "SpeakerCarousel.vue"
export default component.exports